(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@big-d-companies/themes"] = factory();
	else
		root["@big-d-companies/themes"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ThemeProvider: () => (/* reexport */ external_styled_components_namespaceObject.ThemeProvider),
  darkTheme: () => (/* binding */ darkTheme),
  lightTheme: () => (/* binding */ lightTheme),
  signatureTheme: () => (/* binding */ signatureTheme)
});

;// CONCATENATED MODULE: external "styled-components"
const external_styled_components_namespaceObject = require("styled-components");
;// CONCATENATED MODULE: ./src/index.js

const darkTheme = {
  colors: {
    foreground: "white",
    background: "black",
    grey0: "#d9d9d9",
    grey1: "#939293",
    grey2: "#999999",
    grey3: "rgba(255, 255, 255, 0.2)",
    grey4: "#f5f5f5",
    grey5: "#d0d0d0"
  }
};
const lightTheme = {
  colors: {
    foreground: "black",
    background: "white",
    grey0: "#d9d9d9",
    grey1: "#939293",
    grey2: "#999999",
    grey3: "rgba(255, 255, 255, 0.2)",
    grey4: "#f5f5f5",
    grey5: "#d0d0d0"
  }
};
const signatureTheme = {
  colors: {
    foreground: "#1e3040",
    background: "white",
    grey0: "#d9d9d9",
    grey1: "#939293",
    grey2: "#999999",
    grey3: "rgba(255, 255, 255, 0.2)",
    grey4: "#f5f5f5",
    grey5: "#d0d0d0"
  }
};

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map